import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Lock, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { setAdminToken, getAdminToken } from "@/lib/adminAuth";

export default function AdminLogin() {
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (getAdminToken()) navigate("/admin/leads", { replace: true });
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const res = await api.post("/admin/login", { password });
      setAdminToken(res.data.token);
      toast.success("Welcome, admin.");
      navigate("/admin/leads", { replace: true });
    } catch (err) {
      const msg = err?.response?.data?.detail || "Login failed";
      toast.error(msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 pt-16">
      <div data-testid="admin-login-card" className="w-full max-w-md bg-pshl-surface border border-white/10 p-8">
        <div className="flex items-center gap-3">
          <div className="h-12 w-12 grid place-items-center bg-pshl-electric/15 border border-pshl-electric/40">
            <Lock className="h-5 w-5 text-pshl-electric" />
          </div>
          <div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-white/55">PSHL8 · Admin</div>
            <div className="font-display text-2xl text-white tracking-tight">Sign In</div>
          </div>
        </div>
        <p className="mt-5 text-sm text-white/65 leading-relaxed">
          Internal lead-management console. Enter the shared admin password to continue.
        </p>
        <form onSubmit={handleSubmit} className="mt-7 space-y-4">
          <div>
            <label className="pshl-label">Admin Password</label>
            <input
              data-testid="admin-login-password"
              type="password"
              autoComplete="off"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="pshl-input"
              placeholder="•••••••••"
            />
          </div>
          <button
            type="submit"
            disabled={submitting}
            data-testid="admin-login-submit"
            className="w-full inline-flex items-center justify-center gap-2 bg-pshl-electric hover:bg-pshl-electric/90 disabled:opacity-60 text-white font-display uppercase tracking-[0.18em] text-xs px-6 py-3.5 transition-all"
          >
            {submitting ? <Loader2 className="h-4 w-4 animate-spin" /> : <Lock className="h-4 w-4" />}
            {submitting ? "Signing in..." : "Sign In"}
          </button>
        </form>
        <div className="mt-6 text-xs text-white/50">
          <Link to="/" className="hover:text-pshl-electric">← Back to PSHL8</Link>
        </div>
      </div>
    </div>
  );
}
